import { IAppointment } from '../../../API/GoMoto';
import { QRCodeData } from '../../../context/mzero';

/**
 * Decides which locker number a freshly scanned appointment should request.
 *
 * Advisor "Add Key" QR codes generated from dashboard Key Management carry the
 * locker the advisor selected (`result.lockerNumber`). We surface it as the
 * appointment's `keySlotNumber` so the downstream `retrieveAvailableLocker`
 * call requests that exact slot rather than passing 0 (which makes the server
 * auto-assign). Returns `undefined` when there is nothing to apply:
 *  - the QR carried no usable locker number, or
 *  - the appointment already has a stored key (`keySlot` id present), so the
 *    persisted slot must win.
 */
export function resolveScannedKeySlotNumber(
    appointment: IAppointment,
    result: QRCodeData,
): number | undefined {
    if (result.lockerNumber && result.lockerNumber > 0 && !appointment.keySlot) {
        return result.lockerNumber;
    }
    return undefined;
}
